@if ($country()) {
  @if ($hasSubmission() && ($country() === countries.Italy || $country() === countries.Australia)) {
    <sms-regulatory-status></sms-regulatory-status>
  }

  @switch ($country()) {
    @case (countries.SouthAfrica) {
      <sms-south-africa-form></sms-south-africa-form>
    }
    @case (countries.Italy) {
      <sms-italy-form></sms-italy-form>
    }
    @case (countries.Australia) {
      <sms-australia-form></sms-australia-form>
    }
    @case (countries.US) {
      <sms-registration-form-v2></sms-registration-form-v2>
    }
    @default {
      <span>You shouldn't see this</span>
    }
  }
}
